import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Popover, PopoverInteractionKind, Position } from '@blueprintjs/core';
import { V4, expandToMinSize, expandToSquare } from '@moleculeone/utils';
import { SVGMol, SVGMolSpace } from '@moleculeone/ui';

import cls from './DrawnMolecule.module.css';

export { BOND_CUT_APPLIED, BOND_CUT_DESIRED } from '@moleculeone/ui';

export default class extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    drawnMol: PropTypes.object,
    size: PropTypes.arrayOf(PropTypes.number),
    toolbox: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    border: PropTypes.number,
    before: PropTypes.node,
    after: PropTypes.node,
    cutData: PropTypes.object,
    onClick: PropTypes.func,
    onMouseDown: PropTypes.func,
    onMouseUp: PropTypes.func,
    onMouseMove: PropTypes.func,
    idx: PropTypes.string,
  };

  static defaultProps = {
    size: [100, 100, 0],
    border: 20,
    toolbox: true,
  };

  render() {
    const {
      className,
      drawnMol,
      size,
      toolbox,
      border,
      before,
      after,
      cutData,
      onClick,
      onMouseDown,
      onMouseUp,
      onMouseMove,
      idx,
    } = this.props;

    const viewport = expandToSquare(expandToMinSize(drawnMol.bbox, V4.fromArray(size)));

    return (
      <Popover
        className={className}
        targetClassName={className}
        portalClassName={cls.toolboxPopover}
        content={toolbox || null}
        position={Position.TOP}
        interactionKind={PopoverInteractionKind.HOVER}
        transitionDuration={100}
        hoverOpenDelay={300}
        disabled={!toolbox}
        modifiers={{
          computeStyle: {
            gpuAcceleration: false,
          },
        }}
      >
        {/* <div className={cx(cls.drawnMolecule, className, 'molecule')}> */}
        <SVGMolSpace
          className={cx('svg-mol-space', className)}
          viewport={viewport}
          border={border}
          onClick={onClick}
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          onMouseMove={onMouseMove}
        >
          {before}
          <SVGMol drawnMol={drawnMol} cutData={cutData} idx={idx} />
          {after}
        </SVGMolSpace>
        {/* </div> */}
      </Popover>
    );
  }
}
